
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Clock } from "lucide-react";
import { Link } from "react-router-dom";

interface ReadingItem {
  id: number;
  title: string;
  date: string;
  readTime: string;
}

interface ReadingHistoryProps {
  items: ReadingItem[];
}

export const ReadingHistory = ({ items }: ReadingHistoryProps) => (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center">
        <Clock className="mr-2 h-5 w-5" />
        Reading History
      </CardTitle>
      <CardDescription>Your recently read articles</CardDescription>
    </CardHeader>
    <CardContent>
      <div className="space-y-4">
        {items.map((article) => (
          <div key={article.id} className="border-b pb-4 last:border-0 last:pb-0">
            <Link to={`/article/${article.id}`}>
              <h3 className="font-medium hover:text-ai-indigo cursor-pointer">
                {article.title}
              </h3>
            </Link>
            <div className="mt-1 flex items-center justify-between">
              <p className="text-sm text-gray-500">
                {article.readTime} • {article.date}
              </p>
              <Button 
                variant="ghost" 
                size="sm" 
                className="text-gray-500 hover:text-ai-indigo"
                onClick={(e) => {
                  e.preventDefault(); // Prevent triggering the parent Link
                  window.location.href = `/article/${article.id}`;
                }}
              >
                Read Again
              </Button>
            </div>
          </div>
        ))}
      </div>
    </CardContent>
    <CardFooter>
      <Link to="/articles" className="w-full">
        <Button variant="outline" className="w-full">
          View All Reading History
        </Button>
      </Link>
    </CardFooter>
  </Card>
);
